import { render, staticRenderFns } from "./PcVideoSection.vue?vue&type=template&id=1e970afb&scoped=true"
import script from "./PcVideoSection.vue?vue&type=script&lang=ts"
export * from "./PcVideoSection.vue?vue&type=script&lang=ts"
import style0 from "./PcVideoSection.vue?vue&type=style&index=0&id=1e970afb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e970afb",
  null
  
)

export default component.exports